import React, { useState, useEffect, useMemo, useRef } from "react";
import { useTable, useGlobalFilter } from 'react-table';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon,Grid } from 'semantic-ui-react';
import '../css/reconSummary.css';
import Select from "react-select";
import EditIcon from '@mui/icons-material/Edit';
import excelIcon from '../../../assets/images/excel.png';
import FilePreviewer from "../common/file_displayer";

function PurchaseRequirement() {
  const [formData, setFormData] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [formData1, setFormData1] = useState([]);
  const [formData2, setFormData2] = useState([{}]);
  const [formData3, setFormData3] = useState([]);
  const [formData4, setFormData4] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [tablerowData, settableRowData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [fields, setFields] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [columnDefs, setColumnDefs] = useState([]);
  const [tablecolumnDefs, settableColumnDefs] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [fields2, setFields2] = useState([]);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [fields3, setFields3] = useState(null);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [fields4, setFields4] = useState(null);
  const [columnDefs4, setColumnDefs4] = useState([]);
  const [prfno, setPrfno] = useState('');
  const [manager, setManager] = useState('');
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [section3Rows, setSection3Rows] = useState([{}]);
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const [createHidden, setCreateHidden] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [quotations, setQuotations] = useState([{ id: 1, label: "Quotation 1" }]);
  const [selectedQuotationId, setSelectedQuotation] = useState(0);
  const [quotationData, setQuotationData] = useState([]);
  const [options, setOptions] = useState([]);
  const [quotationinputData, setQuotationinputData] = useState([]);
  const [selectedvalue, setSelectedvalue] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const baseUrl = "http://172.16.40.13:1201/static/";

  // State to control collapsibility of divs
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(true);
  const [isDiv3Open, setIsDiv3Open] = useState(true);
  const [isDiv4Open, setIsDiv4Open] = useState(true);
const [gridApi, setGridApi] = useState(null);

const onGridReady = (params) => {
  setGridApi(params.api);
};


  useEffect(() => {
    fetchFieldInfo(70, setFields, setColumnDefs);
    fetchFieldInfo(71, setFields2, setColumnDefs2);
    fetchFieldInfo(68, setFields3, setColumnDefs3);
    fetchFieldInfo(73, setFields4, setColumnDefs4);
    fetchprfTableInfo1();
    fetchtabledetailsInfo();
    console.log(userCredentials)
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault(); // Prevent form default submission behavior
  console.log("form data",e)
};

const gridRef = useRef();

const onBtnExportCSV = () => {
const tabLabel = tabConfig[activeTab]?.title || 'Invoices';
  gridRef.current.api.exportDataAsCsv({
    fileName: `Approver_${tabLabel}_invoices.csv`, // <-- Set your desired file name here
    columnKeys: tablecolumnDefs
      .filter(col => !col.checkboxSelection)
      .map(col => col.field),
    processCellCallback: (params) => params.value ?? '',
  });
};


  const tabConfig = [
    { title: "New", key: "New" },
    { title: "Hold", key: "Hold" },
    { title: "Approved", key: "Approved" },
    { title: "Rejected", key: "Rejected" },
    { title: "All", key: "All" },
  ];


const getFileDataRequired = (responseData) => {
    const dataValues = responseData;
    const requiredFileData = {};

    for (const key in dataValues) {
      if (key.startsWith("file_") && key.endsWith("_type")) {
        const fileTypeValue = dataValues[key];
        const fileIndex = key.split("_")[1]; // Extract the index (e.g., '1' from 'file_1_type')
        if (fileTypeValue.length > 0) {
          const filePath = dataValues[`file_${fileIndex}_path`];
          requiredFileData[`file_${fileIndex}`] = {
            type: fileTypeValue,
            path: filePath,
          };
        }
      }
    }

    return requiredFileData;
  };


    // Helper function to format date
  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const enhanceRowsWithCommonFields = (rows, commonFields) =>
    rows.map(row => ({ ...row, ...commonFields }));

  // Helper function to create payload
  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  // Helper function for Axios requests
  const makeApiRequest = (url, payload, headers) => {
    return axios.post(url, payload, headers)
      .then(response => {
        console.log("API Response:", response);
      })
      .catch(error => {
        console.error("API Error:", error);
        throw new Error("Error with API call");
      });
  };


  const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
    const payload = { headerconfig_id: headerConfigId, "filterconditions": filterconditions };
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
  
        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  

const fetchprfTableInfo1 = async () => {
  const payload = { headerconfig_id: 74, "filterconditions": filterconditions };

  try {
    const FileUploadCredentials = Fetchheaderdata(); // Function to fetch header data
    const response = await axios.post(
      FileUploadCredentials[1], // URL
      payload,                  // Payload
      FileUploadCredentials[0]  // Headers or Credentials
    );

    const data = response.data;
    if (data.fields && data.fields.length > 0) {
      // Map the fields to columns
      const columns = data.fields.map((field) => ({
        headerName: formatColumnName(field.columnName),
        field: field.columnName,
        sortable: true,
        filter: true,
        resizable: true,
        width: 150,
      }));

      // Define the "Select" column
      const selectColumn = {
        headerName: "",
        checkboxSelection: true,
headerCheckboxSelection: true,
headerCheckboxSelectionFilteredOnly: true,
        width: 50,
        pinned: "left", // Optional: pin the column to the left for better visibility
      };


      // Add the "Select" column as the first column
      columns.unshift(selectColumn);

      console.log("Table Column Definitions:", columns);
      settableColumnDefs(columns); // Update state with column definitions
    }
  } catch (error) {
    console.error("Error fetching field info:", error);
    setError("Error fetching fields data");
  } finally {
    setLoading(false); // Ensure loading state is updated even in case of an error
  }
};

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  const navigate = (direction) => {
    if (direction === 'next' && currentIndex < options.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (direction === 'prev' && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

const addRow2 = () => {
  setFormData2((prev) => [...prev, {}]);
};


const deleteRow2 = (index) => {
  setFormData2((prev) => {
    if (prev.length === 1) return prev; // prevent deleting last row
    return prev.filter((_, i) => i !== index);
  });
};


  const getFileType = (filePath) => {
    const extension = filePath.split('.').pop().toLowerCase(); // Get the file extension
    if (extension === 'pdf') {
      return 'pdf';
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
      return 'image';
    }
    return 'unsupported';
  };


  const [currentIndex, setCurrentIndex] = useState(0);
  const currentFile = options[currentIndex];
  const fileType =  currentFile ? getFileType(currentFile.path) : null;

  const handleClick = () => {
if (!selectedRow || selectedRow.length !== 1) {
  alert("Please select one row before clicking.");
  return; // stop further execution
}

   BrsTypeList();
   setCurrentIndex(0);
   fetchinvformdetails();
   setUnMatchedHidden(true);
   setCreateHidden(false);

  };

const handleApproverClick = async () => {
    const formattedDate = getFormattedDate();
  if (!selectedRow || selectedRow.length === 0) {
    alert("Please select one row before clicking.");
    return; // stop further execution
  }
  const payload = {
    schema_name: "payments",
    table: "approved_invoices",
    set_column: {
      is_approver_approved: 1,is_approver_rejected: 0,is_approver_hold: 0,
      invoice_status: "SENT TO FINANCE",approver_approval_date: formattedDate
    },
    where: [{ id : selectedRow.map((row) => (row.id )) }],
  };
  try {
    const FileUploadCredentials = Fetchupdatequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    if (response.status === 200) {
      alert("Invoices approved successfully.");
gridApi.deselectAll();
fetchtabledetailsInfo();
    } else {
      alert("Something went wrong. Please try again.");
    }
    console.log("response", response);
  } catch (error) {
    console.error("Error approving invoice:", error);
    setError("Error approving invoice");
    alert("Failed to approve invoice.");
  }
};

const handleHoldClick = async () => {
    const formattedDate = getFormattedDate();
  if (!selectedRow || selectedRow.length === 0) {
    alert("Please select one row before clicking.");
    return; // stop further execution
  }
  const payload = {
    schema_name: "payments",
    table: "approved_invoices",
    set_column: {
      is_approver_approved: 0,is_approver_rejected: 0,is_approver_hold: 1,
      invoice_status: "HOLD BY APPROVER",approver_approval_date: formattedDate
    },
    where: [{ id: selectedRow[0].id }],
  };
  try {
    const FileUploadCredentials = Fetchupdatequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    if (response.status === 200) {
      alert("Invoices Kept on Hold successfully.");
gridApi.deselectAll();
fetchtabledetailsInfo();
    } else {
      alert("Something went wrong. Please try again.");
    }
    console.log("response", response);
  } catch (error) {
    console.error("Error approving invoice:", error);
    setError("Error approving invoice");
    alert("Failed to approve invoice.");
  }
};

const handleRejectClick = async () => {
    const formattedDate = getFormattedDate();
  if (!selectedRow || selectedRow.length === 0) {
    alert("Please select one row before clicking.");
    return; // stop further execution
  }
  const payload = {
    schema_name: "payments",
    table: "approved_invoices",
    set_column: {
      is_approver_approved: 0,is_approver_rejected: 1,is_approver_hold: 0,
      invoice_status: "REJECTED BY APPROVER",approver_approval_date: formattedDate
    },
    where: [{ id: selectedRow[0].id }],
  };
  try {
    const FileUploadCredentials = Fetchupdatequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    if (response.status === 200) {
      alert("Invoices Rejected successfully.");
      gridApi.deselectAll();
fetchtabledetailsInfo();
    } else {
      alert("Something went wrong. Please try again.");
    }
    console.log("response", response);
  } catch (error) {
    console.error("Error approving invoice:", error);
    setError("Error approving invoice");
    alert("Failed to approve invoice.");
  }
};


  const handleClick1 = () => {
   setFormData1([]);
   setFormData2([{}]);
   setFormData3([]);
   setFormData4([]);
   fetchFieldInfo(70, setFields, setColumnDefs);
   fetchFieldInfo(71, setFields2, setColumnDefs2);
   fetchFieldInfo(68, setFields3, setColumnDefs3);
   fetchFieldInfo(73, setFields4, setColumnDefs4);
   fetchtabledetailsInfo();
gridApi.deselectAll();
setSelectedRow(null); // clear your state too

   setUnMatchedHidden(false);
   setCreateHidden(true);
  };


  const fetchtabledetailsInfo = async () => {
        setLoading(true);
  const formatted = userCredentials.division.join(",");
  console.log("activeTab",activeTab);

  let condition = "is_purchase_level_2_approved = 0 AND is_purchase_level_2_rejected = 0 AND is_purchase_level_2_hold = 0 AND is_approver_approved = 0 AND is_approver_rejected = 0 AND is_approver_hold = 0 AND is_finance_approved = 0 AND is_finance_rejected = 0 AND is_finance_hold = 0 AND";

  if (activeTab === 1) {
    condition = "((is_purchase_level_2_approved = 0 AND is_purchase_level_2_rejected = 0 AND is_purchase_level_2_hold = 1) or (is_approver_approved = 0 AND is_approver_hold = 1 AND is_approver_rejected = 0) or (is_finance_approved = 0 AND is_finance_rejected = 0 AND is_finance_hold = 1)) AND";
  } else if (activeTab === 2) {
    condition = "((is_purchase_level_2_approved = 1 AND is_purchase_level_2_rejected = 0 AND is_purchase_level_2_hold = 0) or (is_approver_approved = 1 AND is_approver_hold = 0 AND is_approver_rejected = 0) or (is_finance_approved = 1 AND is_finance_rejected = 0 AND is_finance_hold = 0)) AND";
  } else if (activeTab === 3) {
    condition = "((is_purchase_level_2_approved = 0 AND is_purchase_level_2_rejected = 1 AND is_purchase_level_2_hold = 0) or (is_approver_approved = 0 AND is_approver_hold = 0 AND is_approver_rejected = 1) or (is_finance_approved = 0 AND is_finance_rejected = 1 AND is_finance_hold = 0)) AND";
  } else if (activeTab === 4) {
    condition = ""; // For "All"
  }

    const payload = { query: `SELECT IFNULL(TRIM(vendor_name), '') AS 'vendor_name', IFNULL(TRIM(vendor_address), '') AS 'vendor_address',
 IFNULL(TRIM(place_of_supply), '') AS 'place_of_supply', IFNULL(TRIM(invoice_number), '') AS 'invoice_number', IFNULL(DATE_FORMAT(invoice_date, '%d-%m-%Y'),
 '') AS 'invoice_date', IFNULL(CONVERT(total_invoice_amount, CHAR), '0.00') AS 'total_invoice_amount', IFNULL(TRIM(purchase_order_number), '') AS 'purchase_order_number',
 IFNULL(DATE_FORMAT(purchase_order_date, '%d-%m-%Y'), '') AS 'purchase_order_date', IFNULL(TRIM(cost_center_code), '') AS 'cost_center_code',
 IFNULL(TRIM(approver_mail_id), '') AS 'approver_mail_id', IFNULL(TRIM(expense_code), '') AS 'expense_code', IFNULL(TRIM(expense_category), '') AS 'expense_category',
 IFNULL(TRIM(invoice_type), '') AS 'invoice_type', IFNULL(TRIM(invoice_user_mail_id), '') AS 'invoice_user_mail_id', IFNULL(TRIM(invoice_extraction_type), '') AS 'invoice_extraction_type',
 IFNULL(TRIM(sbi_cost_center_code), '') AS 'sbi_cost_center_code', IFNULL(TRIM(sbi_site_code), '') AS 'sbi_site_code', IFNULL(TRIM(site_name), '') AS 'sbi_site_name',
 IF(sbi_billable = 0, 'NO', 'YES') AS 'sbi_billable', IFNULL(TRIM(unique_number), '') AS 'unique_number',invoice_status, IFNULL(TRIM(revenue_invoice_number), '') AS 'revenue_invoice_number',
 id, purchase_order_mapped_id, IFNULL(TRIM(month_of_service), '') AS 'month_of_service', IFNULL(TRIM(approver_id), '') AS 'approver_id'
 FROM payments.approved_invoices WHERE (is_purchase_approved = 1 OR is_purchase_level_2_approved = 1) 
AND ${condition} is_active = 1 and invoice_type IN (
    SELECT name 
    FROM user_management_uat.divisions 
    WHERE division_id IN (${formatted})
  );
   ` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
        settableRowData(null);
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        settableRowData(data);
        setLoading(false);
      }
        setLoading(false);

    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
        settableRowData(null);
        setLoading(false);
    }
  };
  useEffect(() => {
    fetchtabledetailsInfo();
  }, [activeTab]);


  const fetchinvformdetails = async () => {
    
    const payload = { query: `select *,IFNULL(DATE_FORMAT(invoice_date, '%d-%m-%Y'), '') AS 'invoice_date',IFNULL(DATE_FORMAT(purchase_order_date, '%d-%m-%Y'), '') AS 'purchase_order_date' from payments.approved_invoices where id = ${selectedRow[0].id};` };
    const payload_1 = { query: `select * from payments.approved_invoices_line where approved_invoice_id = ${selectedRow[0].id};` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;

      const response_1 = await axios.post(
        FileUploadCredentials[1],
        payload_1,
        FileUploadCredentials[0]
      );

      const data_1 = response_1.data;


if (Array.isArray(data) && data.length > 0) {
  setFormData(data[0]);
  setFormData3(data[0]);
  setFormData4(data[0]);

} else {
  setFormData([]); // or setFormData({}) depending on your default
  setFormData3([]);
  setFormData4([]);
}

console.log("data_1",data)

if (Array.isArray(data_1) && data_1.length > 0) {
  setFormData2(data_1);

} else {
  setFormData2([{}]); // or setFormData({}) depending on your default
}

    } catch (error) {
      console.error("Error fetching invoice data:", error);
      setError("Error fetching invoice data");
    }
  };
// Helper to convert DD-MM-YYYY to MySQL DATETIME
const convertToMySQLDateTime = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split('-');
  const date = new Date(`${year}-${month}-${day}T00:00:00`);
  // Format to YYYY-MM-DD HH:MM:SS
  const pad = (n) => n.toString().padStart(2, '0');
  const formatted = `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  return formatted;
};


const handleDeleteClick = async () => {
  // Ask for confirmation
  const confirmDelete = window.confirm("Are you sure you want to delete?");
  if (!confirmDelete) return; // Stop if user cancels

  try {
    const update_payload_1 = {
      schema_name: "payments",
      table: "purchase_order_mapped",
      set_column: { is_active: 0 },
      where: [{ id: selectedRow[0].id }],
    };
    const FileUploadCredentials_1 = Fetchupdatequery();
    await axios.post(FileUploadCredentials_1[1], update_payload_1, FileUploadCredentials_1[0]);
    fetchtabledetailsInfo();
    alert("Deleted successfully ?");

  } catch (error) {
    console.error("Error deleting row:", error);
    alert("Failed to delete. Please try again ?");
  }
};



  function BrsTypeList() {
    console.log(selectedRow);
    let payload = {
      query : `SELECT IFNULL(TRIM(file_1_type), '') AS 'file_1_type', IFNULL(TRIM(file_1_path), '') AS 'file_1_path', IFNULL(TRIM(file_2_type), '') AS 'file_2_type', IFNULL(TRIM(file_2_path), '') AS 'file_2_path', IFNULL(TRIM(file_3_type), '') AS 'file_3_type', IFNULL(TRIM(file_3_path), '') AS 'file_3_path', IFNULL(TRIM(file_4_type), '') AS 'file_4_type', IFNULL(TRIM(file_4_path), '') AS 'file_4_path', IFNULL(TRIM(file_5_type), '') AS 'file_5_type', IFNULL(TRIM(file_5_path), '') AS 'file_5_path', IFNULL(TRIM(file_6_type), '') AS 'file_6_type', IFNULL(TRIM(file_6_path), '') AS 'file_6_path', IFNULL(TRIM(file_7_type), '') AS 'file_7_type', IFNULL(TRIM(file_7_path), '') AS 'file_7_path', IFNULL(TRIM(file_8_type), '') AS 'file_8_type', IFNULL(TRIM(file_8_path), '') AS 'file_8_path', IFNULL(TRIM(file_9_type), '') AS 'file_9_type', IFNULL(TRIM(file_9_path), '') AS 'file_9_path', IFNULL(TRIM(file_10_type), '') AS 'file_10_type', IFNULL(TRIM(file_10_path), '') AS 'file_10_path' FROM payments.adhoc_invoice_details WHERE id in (select adhoc_invoice_details_id from payments.purchase_order_mapped where id = ${selectedRow[0].purchase_order_mapped_id});`
    }
    console.log('payload', payload);
    var getProcessingLayerList = Fetchexecutequery();
    console.log("brs", getProcessingLayerList)

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing customer List vendor code!!!", response)
          
          let properData = response["data"];
          const purchaseOrdersList = properData.map((data) =>
          getFileDataRequired(data)
        );
	console.log("purchaseOrdersList",purchaseOrdersList)
        // Extract file paths
        const files = [];
        purchaseOrdersList.forEach((fileData) => {
          for (const key in fileData) {
           const fileEntry = fileData[key];
        // Ensure fileEntry is an object and has a path property
        console.log("file paths",files,fileEntry)
        if (fileEntry && typeof fileEntry === "object" && "path" in fileEntry) {
            files.push({
              path: fileEntry.path
            });
          }
          }
        });
	console.log("options",files)
	const formattedOptions = files.map((file, index) => ({
	  label: file,       // The text displayed in the dropdown
	  key: index,       // A unique key for each option
	  value: `${file.path}`,      // The value that will be passed to onChange
	}));
	console.log("formattedOptions",formattedOptions)
        setOptions(files);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);
        }
      );
  }


  const handleInputChange = (name, value) => {
    console.log("formdata",formData)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

const handleInputChange12352 = (index, name, value) => {
  console.log(index, name, value);
  setFormData2((prev) => {
    const updated = [...prev];
    updated[index] = { ...updated[index], [name]: value };
    return updated;
  });
};
const handleInputChange2 = (index, name, value) => {
  console.log(index, name, value);
  setFormData2((prev) => {
    const updated = [...prev];
    let row = { ...updated[index] };

    const percentValue = Number(value) || 0;
    const quantity = Number(row.quantity) || 0;
    const rate = Number(row.rate_per_unit) || 0;
    let line_amount = Number(row.line_amount) || 0;

    // --- GST logic ---
    if (name === "line_sgst_percent") {
      row.line_sgst_percent = percentValue;
      row.line_cgst_percent = percentValue;
      row.line_igst_percent = 0;

      row.line_sgst_amount = (line_amount * percentValue) / 100;
      row.line_cgst_amount = (line_amount * percentValue) / 100;
      row.line_igst_amount = 0;
    } else if (name === "line_cgst_percent") {
      row.line_sgst_percent = percentValue;
      row.line_cgst_percent = percentValue;
      row.line_igst_percent = 0;

      row.line_sgst_amount = (line_amount * percentValue) / 100;
      row.line_cgst_amount = (line_amount * percentValue) / 100;
      row.line_igst_amount = 0;
    } else if (name === "line_igst_percent") {
      row.line_sgst_percent = 0;
      row.line_cgst_percent = 0;
      row.line_igst_percent = percentValue;

      row.line_sgst_amount = 0;
      row.line_cgst_amount = 0;
      row.line_igst_amount = (line_amount * percentValue) / 100;
    }

    // --- Amount logic (quantity * rate_per_unit) ---
    if (name === "quantity" || name === "rate_per_unit") {
      const newQuantity = name === "quantity" ? Number(value) || 0 : quantity;
      const newRate = name === "rate_per_unit" ? Number(value) || 0 : rate;
      row.quantity = newQuantity;
      row.rate_per_unit = newRate;

      row.line_amount = newQuantity * newRate;
      line_amount = row.line_amount; // update local amount for GST calculations

      // Recalculate GST amounts with updated amount
      if (row.line_sgst_percent || row.line_cgst_percent) {
        row.line_sgst_amount = (row.line_amount * row.line_sgst_percent) / 100;
        row.line_cgst_amount = (row.line_amount * row.line_cgst_percent) / 100;
      }
      if (row.line_igst_percent) {
        row.line_igst_amount = (row.line_amount * row.line_igst_percent) / 100;
      }
    } else if (
      name !== "line_sgst_percent" &&
      name !== "line_cgst_percent" &&
      name !== "line_igst_percent"
    ) {
      // Normal update
      row[name] = value;
    }

    // --- Calculate total line amount ---
row.amount = Number(
  (
    (Number(row.line_amount) || 0) +
    (Number(row.line_sgst_amount) || 0) +
    (Number(row.line_cgst_amount) || 0) +
    (Number(row.line_igst_amount) || 0)
  ).toFixed(2)
);

    updated[index] = row;

    // --- Calculate totals across all rows ---
    const totals = updated.reduce(
      (acc, r) => {
        acc.invoice_amount += Number(r.line_amount) || 0;
        acc.sgst_amount += Number(r.line_sgst_amount) || 0;
        acc.cgst_amount += Number(r.line_cgst_amount) || 0;
        acc.igst_amount += Number(r.line_igst_amount) || 0;
        acc.total_invoice_amount += Number(r.amount) || 0;
        return acc;
      },
      {
        invoice_amount: 0,
        sgst_amount: 0,
        cgst_amount: 0,
        igst_amount: 0,
        total_invoice_amount: 0,
      }
    );

    // --- Push totals to formData3 ---
    setFormData3((prev3) => ({
      ...prev3,
      ...totals,
    }));

    return updated;
  });
};


  const handleInputChange3 = (name, value) => {
    console.log("formdata4",formData4)
    setFormData4((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const validateField = (value, type) => {
      if (!type) return true; // If no type is defined, skip validation

      switch (type.value) {
          case "text":
              return true; // Allow any text input
          case "integer":
              return /^-?\d*$/.test(value); // Allow integers (positive or negative) and empty input for partial typing
          case "decimal":
              return /^-?\d*\.?\d*$/.test(value); // Allow numbers with optional decimal points
          case "date":
              return !isNaN(Date.parse(value)); // Validate as a valid date
          default:
              return true; // For unsupported types, skip validation
      }
  };


  const handleInputChange1 = (name, value, index,type) => {
    console.log("section2rows",section2Rows)
    setSection2Rows(prevRows => {
      const updatedRows = [...prevRows];
      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      // Update the field with the new value
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the updated field is 'quantity' or 'unit_value', recalculate 'total_value'
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      // Return the updated rows after modifying the necessary fields
      return updatedRows;
    });
  };



  const handlequotatationInputChange3 = (name, value, index,type) => {
    // First, update section3Rows
    console.log(section3Rows,index,quotationinputData)
    setSection3Rows(prevRows => {
      const updatedRows = [...prevRows];
      if (!Number.isInteger(index) || index < 0 || index >= updatedRows.length) {
        console.warn(`Invalid row index: ${index}. Defaulting to 0.`);
        index = 0; // Default index to 0 if invalid
      }

      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      return updatedRows;
    });
    // Then, update quotationinputData
    setQuotationinputData(prevQuotationData => {
      const updatedQuotationData = [...prevQuotationData];

      // Initialize section3Rows for the selectedQuotationId if it doesn't exist
      if (!updatedQuotationData[selectedQuotationId]) {
        updatedQuotationData[selectedQuotationId] = [];
      }

      // Ensure the row exists in quotationData for the current index
      if (!updatedQuotationData[selectedQuotationId][index]) {
        updatedQuotationData[selectedQuotationId][index] = {};
      }


      // Update the specific field in quotationData
      updatedQuotationData[selectedQuotationId][index][name] = value;

      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedQuotationData[selectedQuotationId][index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;

        // Update the total_value in the row for quotationData
        updatedQuotationData[selectedQuotationId][index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }

      return updatedQuotationData;
    });
  };

  const onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows); // Get the first selected row (single selection)

  };


  const handleQuotationChange = (name, value) => {
    setFormData2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Update quotationData with the current quotation's edited data
    setQuotationData((prevData) => ({
      ...prevData,
      [selectedQuotationId]: {
        ...prevData[selectedQuotationId],
        [name]: value,
      },
    }));
    console.log("Updated field:",quotations, name, "with value:", value,quotationinputData);
  };



  // Toggle div visibility
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const toggleDiv3 = () => setIsDiv3Open(!isDiv3Open);
  const toggleDiv4 = () => setIsDiv4Open(!isDiv4Open);



  return (
<>
<LoaderComponent loaderOpen={loading} />

<div>
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#0a2352", fontSize: '18px' }}>
        Invoice Details Viewer
      </h2>
    </div>
    <div hidden={unMatchedHidden}>
<Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
        {/* Tab headers */}
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
  <TabList style={{ display: 'flex' }}>
    {tabConfig.map((tab, i) => (
      <Tab key={i} style={{ width: '150px', textAlign: 'center' }}>
        {tab.title}
      </Tab>
    ))}
  </TabList>
  <div style={{ display: "flex", alignItems: "center", gap: "15px",paddingRight:"5px" }}>
    <input
      className="search-input"
      type="text"
      placeholder="Search..."
      value={globalFilter}
      onChange={(e) => {
        setGlobalFilter(e.target.value);
        gridRef.current.api.setQuickFilter(e.target.value);
      }}
      style={{
        width: "280px",           // ? Wider search bar
        backgroundColor: "white",
        padding: "7px 12px",
        height: "34px",
        lineHeight: "34px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        boxSizing: "border-box",
      }}
    />

    <img
      src={excelIcon}
      alt="Export to Excel"
      title="Download Excel"
      onClick={onBtnExportCSV}
      style={{
        width: "28px",
        height: "28px",
        cursor: "pointer",
      }}
    />
  </div>
</div>

        {/* Tab content */}
        {tabConfig.map((tab, i) => (
          <TabPanel key={i}>
                    <div
                      className="ag-theme-alpine"
                      style={{
                        overflowX: "auto",
                        overflowY: "auto",
                        borderRadius: "10px",
                        width: `${tablecolumnDefs.length * 150}px`,
                        maxWidth: "100%",
                        height: "543px",
                        paddingTop: "10px",
                      }}
                    >
                      <AgGridReact
                        onGridReady={onGridReady}
                        columnDefs={tablecolumnDefs}
                        rowData={tablerowData}
                        animateRows={true}
              		ref={gridRef}
                        pagination={true}
                        paginationPageSize={11}
                        rowSelection="single"
                        onSelectionChanged={onSelectionChanged}
              		enableCellTextSelection={true}
              		suppressCopyRows={true} 

                      />
                    </div>

                    {/* Action Buttons */}
                    <div className="submit-row">
                      <div>
                        <button className="submit-btn" onClick={handleClick}>
                          VIEW
                        </button>
                      </div>

                    </div>
          </TabPanel>
        ))}
      </Tabs>

	</div>
<div hidden={createHidden}>

  <div style={{  textAlign: 'center' }}>

    {/* Navigation Buttons */}

<div style={{ display: 'flex', gap: '10px' }}>
<div style = {{ width: "120%"}}>
    <div style={{ marginBottom: '10px' }}>
      <button
        onClick={() => navigate('prev')}
        disabled={currentIndex === 0}
        style={{ marginRight: '10px' }}
      >
        Previous
      </button>
      <button
        onClick={() => navigate('next')}
        disabled={currentIndex === options.length - 1}
      >
        Next
      </button>
    </div>

    {/* Guard Clause for currentFile */}
    {currentFile ? (
      <div style={{ textAlign: 'center',   marginLeft: '10px' }}>
        <h3>{currentFile.path.split('/').pop()}</h3> {/* Display file name */}

  {/* <div style={{ maxWidth: "790px", minWidth: "300px"  ,overflowX: "auto" }}> */}
<div
  style={{
    maxWidth: "790px",
    minWidth: "300px",
    height: "620px",
    overflowX: "auto", // scroll inside this div
    border: "1px solid #ccc",
  }}
>
  {currentFile && fileType === "pdf" && (
    <FilePreviewer
      fileType="pdf"
      fileUrl={`http://206.1.17.185:1200/api/v2/user_modules/serve-pdf/${currentFile.path.split('/').pop()}`}
      style={{ height: "100%", width: "100%" }} // make the PDF fit
    />
  )}
</div>
        {fileType === 'image' && (
          <img
            src={`${baseUrl}/${currentFile.path}`}
            alt="Preview"
            style={{ maxWidth: '100%', maxHeight: '500px' }}
          />
        )}
        {fileType === 'unsupported' && (
          <h4 style={{ color: 'red' }}>Unsupported file type</h4>
        )}
      </div>

    ) : (
      <h3>No files to preview</h3> // Fallback UI if no files are available
    )}
</div>

<div style = {{width:'50%'}}>
          <div>
            <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
          </div>
<div style = {{ marginLeft: "20px", borderRadius: "8px", backgroundColor:'white'}}>
{formData2.length > 0 ? (
  formData2.map((row, index) => (
    <div
      key={index}
      style={{
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "5px", display:"flex", 
      }}
    >

      {/* Horizontal scroll container */}
      <div
        style={{
          maxWidth: "100%",
          overflowX: "auto", display:"flex" ,
          paddingBottom: "5px", // space between fields and scrollbar
        }}
      >

        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "nowrap",
          }}
        >
          {fields2.map((field, fieldIndex) => {
            if (!field.function) return null;

            return (
              <div
                key={fieldIndex}
                style={{
                  minWidth:
                    field.width.value === "s"
                      ? "15%"
                      : field.width.value === "m"
                      ? "20%"
                      : "30%",
                }}
              >
                <label
                  className="form-label"
                  style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}
                >
                  {field.renameValue || formatColumnName(field.columnName)}:
                </label>

                {field.function === "Input Field" ? (
                  <input
                    type={
                      field.type?.value === "decimal" || field.type?.value === "integer"
                        ? "number"
                        : "text"
                    }

                    name={field.columnName}
                    value={
  field.type?.value === "text"
    ? (row[field.columnName] || "")
    : row[field.columnName] !== undefined && row[field.columnName] !== null
      ? String(row[field.columnName])
      : ""
}


                    onChange={(e) =>
                      handleInputChange2(index, field.columnName, e.target.value, field.type)
                    }
                    className="form-control"
                  />
                ) : (
                  <div
                    className="form-control"
                    style={{ background: "#f5f5f5", minHeight: "30px" }}
                  >
                    {row[field.columnName] || 0.00}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

    </div>
  ))
) : (
  <p>No rows yet. Click + to add one.</p>
)}
</div>
          <div>
            <DynamicForm fields={fields3} formData={formData3} onInputChange={handleInputChange} onSubmit={handleSubmit} />
          </div>

          <div>
            <DynamicForm fields={fields4} formData={formData4} onInputChange={handleInputChange3} onSubmit={handleSubmit} />
          </div>

<div style = {{display : "flex",marginLeft:"10px"}} >
      <div>
        <button
          className="submit-btn"
          onClick={handleClick1}
        >
          Back
        </button>
      </div>
</div>


</div>
  </div>
</div>
</div>
</div>
</>
  );
}

export default PurchaseRequirement;